export default __webpack_public_path__ + "static/media/crowdloan-banner.33f85a01.png";